<template>
  <BModal
    id="modal-pin"
    centered
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    content-class="w-160 h-26 mx-auto"
    header-class="border-0 pb-0 bg-white"
    body-class="px-2 pb-2 pt-0 bg-white"
  >
    <template #modal-header>
      <div class="w-100 text-center pt-2 px-3 bg-white">
        <h5 class="h2 font-weight-bold text-dark mb-0">
          Masukkan PIN
        </h5>
      </div>
      <span
        style="position: absolute; right: 16px; top: 16px; font-size: 20px; cursor: pointer; color: #000;"
        @click="handleCancel"
      >&times;</span>
    </template>

    <p
      class="text-center text-muted pt-2 mb-1"
      style="font-size: 14px;"
    >
      Masukkan PIN kamu
    </p>

    <div
      class="d-flex justify-content-center mb-1"
      style="gap: 16px;"
    >
      <input
        v-for="(_, index) in pinDigits"
        :key="index"
        :ref="`pin${index}`"
        :value="showPin ? pinDigits[index] : (pinDigits[index] ? '•' : '')"
        type="text"
        maxlength="1"
        class="bg-transparent border-0 text-center p-0"
        style="width: 30px; font-size: 22px; font-weight: 600; border-bottom: 2px solid #aaa !important; outline: none; color: #333;"
        @keydown="onKeydown($event, index)"
        @paste.prevent="onPaste"
      >
    </div>

    <div
      class="text-center mb-1"
      style="min-height: 22px;"
    >
      <span
        v-if="pinValue.length > 0"
        class="text-danger"
        style="font-size: 13px; cursor: pointer;"
        @click="showPin = !showPin"
      >
        {{ showPin ? 'Sembunyikan' : 'Tampilkan' }}
      </span>
    </div>

    <p
      v-if="errorMsg"
      class="text-danger text-center mb-3"
      style="font-size: 13px;"
    >
      {{ errorMsg }}
    </p>

    <div
      class="d-flex"
      style="gap: 10px;"
    >
      <BButton
        variant="link"
        class="button-orange w-full"
        @click="handleCancel"
      >
        Batal
      </BButton>
      <BButton
        variant="link"
        :class="pinValue.length >= PIN_LENGTH ? 'button-orange-active' : 'button-disabled'"
        class="w-full"
        :disabled="pinValue.length < PIN_LENGTH || loading"
        @click="handleVerify"
      >
        <BSpinner
          v-if="loading"
          small
        />
        <span v-else>Verifikasi</span>
      </BButton>
    </div>
  </BModal>
</template>

<script>
export default {
  name: 'ModalPin',
  emits: ['verified', 'cancel'],
  data() {
    return {
      PIN_LENGTH: 6,
      pinDigits: Array(6).fill(''),
      showPin: false,
      errorMsg: '',
      loading: false,
    }
  },
  computed: {
    pinValue() {
      return this.pinDigits.join('')
    },
  },
  methods: {
    onKeydown(event, index) {
      const { key } = event

      if (key === 'Backspace') {
        event.preventDefault()
        if (this.pinDigits[index]) {
          this.$set(this.pinDigits, index, '')
        } else if (index > 0) {
          this.$set(this.pinDigits, index - 1, '')
          this.$nextTick(() => {
            const prev = this.$refs[`pin${index - 1}`]
            if (prev && prev[0]) prev[0].focus()
          })
        }
        return
      }

      if (!/^\d$/.test(key)) {
        event.preventDefault()
        return
      }

      event.preventDefault()
      this.$set(this.pinDigits, index, key)
      if (index < this.PIN_LENGTH - 1) {
        this.$nextTick(() => {
          const next = this.$refs[`pin${index + 1}`]
          if (next && next[0]) next[0].focus()
        })
      }
    },

    onPaste(event) {
      const pasted = event.clipboardData.getData('text').replace(/\D/g, '').slice(0, this.PIN_LENGTH)
      pasted.split('').forEach((char, i) => this.$set(this.pinDigits, i, char))
      this.$nextTick(() => {
        const last = this.$refs[`pin${Math.min(pasted.length, this.PIN_LENGTH - 1)}`]
        if (last && last[0]) last[0].focus()
      })
    },

    async handleVerify() {
      this.loading = true
      this.errorMsg = ''
      this.$emit('verified', this.pinValue)
    },

    handleCancel() {
      this.reset()
      this.hide()
      this.$emit('cancel')
    },

    reset() {
      this.pinDigits = Array(this.PIN_LENGTH).fill('')
      this.errorMsg = ''
      this.loading = false
      this.showPin = false
    },

    setError(msg) {
      this.errorMsg = msg
      this.pinDigits = Array(this.PIN_LENGTH).fill('')
      this.loading = false
      this.showPin = false
      this.$nextTick(() => {
        const first = this.$refs.pin0
        if (first && first[0]) first[0].focus()
      })
    },

    show() {
      this.reset()
      this.$bvModal.show('modal-pin')
    },

    hide() {
      this.$bvModal.hide('modal-pin')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './CredentialManagement.scss';
</style>
